import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 7.698,
	height: 12.701,
	viewBox: "0 0 7.698 12.701",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "down-arrow",
		d: "M33.078,2.314l.646.646a.7.7,0,0,1,0,.986L28.071,9.6a.7.7,0,0,1-.986,0L21.43,3.947a.7.7,0,0,1,0-.986l.648-.647a.7.7,0,0,1,.99,0l.01.01,3.34,3.506L27.6,7.01l1.142-1.178,3.334-3.506a.7.7,0,0,1,.981-.031l.019.019",
		transform: "translate(-2.107 33.927) rotate(-90)",
		fill: "#8bd2f5"
	})
});
export default SvgChevronRight;
